const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const verified=v=>String(v||'').toUpperCase()==='VERIFIED';

export function deriveMoatEvidence(bundle={}){
  const m=bundle?.secFinancials?.metrics||{};
  const gross=N(m.grossMarginPct),operating=N(m.operatingMarginPct);
  const ocf=N(m.operatingCashFlowAnnual),net=N(m.netIncomeAnnual);
  const conversion=ocf!=null&&net!=null&&net!==0?ocf/net:null;

  let economics='MISSING';
  if(gross!=null||operating!=null){
    if(gross!=null&&operating!=null&&gross>=40&&operating>=15)economics='SUPPORTIVE';
    else if((gross!=null&&gross>0)||(operating!=null&&operating>0))economics='MIXED';
    else economics='CAUTION';
  }

  let cashConversion='MISSING';
  if(conversion!=null){
    cashConversion=conversion>=1?'SUPPORTIVE':conversion>=0.7?'MIXED':'CAUTION';
  }

  const demandRows=Array.isArray(bundle?.demand)?bundle.demand:[];
  const verifiedDemand=demandRows.filter(r=>verified(r?.verification_status));
  const validatedDemand=verifiedDemand.filter(r=>r?.customer_validation!=null&&String(r.customer_validation).trim()!=='');
  const customerEvidence=validatedDemand.length?'PRESENT':verifiedDemand.length?'PARTIAL':'MISSING';

  const relationships=Array.isArray(bundle?.relationships)?bundle.relationships:[];
  const verifiedRelationships=relationships.filter(r=>verified(r?.verification_status));
  const ecosystemEvidence=verifiedRelationships.length?'PRESENT':'MISSING';

  let state='REVIEW';
  if(economics==='SUPPORTIVE'&&cashConversion==='SUPPORTIVE'&&(customerEvidence==='PRESENT'||ecosystemEvidence==='PRESENT'))state='EVIDENCE_STACKED';
  else if(economics==='SUPPORTIVE'&&cashConversion==='SUPPORTIVE')state='ECONOMIC_SUPPORT_ONLY';
  else if([economics,cashConversion].some(x=>['SUPPORTIVE','MIXED','CAUTION'].includes(x))||customerEvidence!=='MISSING'||ecosystemEvidence!=='MISSING')state='MIXED_EVIDENCE';

  return{
    status:state==='REVIEW'?'MISSING':'EVIDENCE',
    state,
    economics,
    cashConversion,
    customerEvidence,
    ecosystemEvidence,
    grossMarginPct:gross,
    operatingMarginPct:operating,
    cashConversionRatio:conversion,
    verifiedDemandRows:verifiedDemand.length,
    validatedDemandRows:validatedDemand.length,
    verifiedRelationshipRows:verifiedRelationships.length,
    note:'Moat Evidence separates economic quality from direct customer/ecosystem evidence. It does not assign a wide/narrow moat rating, trade signal or capital permission.'
  };
}
